
<template>
  <el-card shadow="always">
    <div slot="header" class="clearfix">
      <span>Importar</span>
    </div>
    <div>
      <el-alert
        description="ARQUIVOS SOMENTE NO FORMATO .CSV ou .TXT INFORME OS DADOS PARA A IMPORTAÇÃO LOGO ABAIXO"
        type="success"
        :closable="false"
      >
      </el-alert>
      <br />
      <el-form ref="form" :model="deliveryForm" label-width="120px">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="$t('importar')" prop="import">
              <el-select v-model="deliveryForm.type" placeholder="Selecione">
                <el-option key="1" label="Pré-Postagem" value="1"></el-option>
                <el-option key="2" label="Destinatário" value="2"></el-option> 
                <el-option v-if="userType === '1'" key="3" label="Pré-Postagem da Auditoria" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <br />
      <ImportPrepost
        v-if="deliveryForm.type == 1"
        v-bind:type="deliveryForm.type"
      />
      <ImportDelivery
        v-if="deliveryForm.type == 3"
        v-bind:type="deliveryForm.type"
      />
      <ImportCustomer
        v-if="deliveryForm.type == 32"
        v-bind:type="deliveryForm.type"
      />
      <ImportSender
        v-if="deliveryForm.type == 3"
        v-bind:type="deliveryForm.type"
      />
      <ImportFallObject
        v-if="deliveryForm.type == 4"
        v-bind:type="deliveryForm.type"
      />
      <ImportCheck
        v-if="deliveryForm.type == 6"
        v-bind:type="deliveryForm.type"
      />
    </div>
  </el-card>
</template>

<script>
import ImportCheck from './ImportCheck';
import ImportCustomer from './ImportCustomer';
import ImportDelivery from './ImportDelivery';
import ImportFallObject from './ImportFallObject';
import ImportPrepost from './ImportPrepost';
import ImportSender from './ImportSender';

export default {
  name: 'ImportMain',
  components: {
    ImportPrepost,
    ImportCustomer,
    ImportDelivery,
    ImportSender,
    ImportFallObject,
    ImportCheck,
  },
  data() {
    return {
      userType: '2',
      deliveryForm: {
        type: '',
      },
    };
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
